<template>
    <section class="rtb-form-section" data-field="frame_gids">
        <fieldset class="rtb-form-fieldset">
            <legend class="rtb-form-fieldset__legend">
                <span>{{ title }}</span>
                <button
                    v-if="selectedGids.length > 0"
                    type="button"
                    class="btn btn--secondary btn--small"
                    :disabled="exporting"
                    @click="emit('export-screens')"
                >
                    {{ exporting ? 'Выгрузка…' : `Скачать Excel (${selectedGids.length})` }}
                </button>
            </legend>
            <p v-if="hint" class="field__hint">{{ hint }}</p>
            <p v-if="errors.frame_gids" class="field__error">{{ errors.frame_gids }}</p>
            <div v-if="loading" class="map-loading-hint">Загрузка карты…</div>
            <slot v-else-if="showMap" />
            <p v-else class="field__hint">{{ emptyText }}</p>
            <p v-if="notice" class="field__hint field__hint--below">{{ notice }}</p>
        </fieldset>
    </section>
</template>

<script setup>
defineProps({
    title: { type: String, default: 'Экраны' },
    hint: { type: String, default: 'Выберите экраны вручную на карте.' },
    emptyText: { type: String, default: 'Нет доступных экранов.' },
    selectedGids: { type: Array, default: () => [] },
    exporting: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    showMap: { type: Boolean, default: true },
    notice: { type: String, default: '' },
    errors: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['export-screens']);
</script>
